<template>
  <div id="pageNotFound" class="center page-not-found flex-mid">
    <div class="pb-40">
      <div class="number">404</div>
      <div class="text fs-40">Looks like something went wrong</div>
      <div class="fs-24 mb-40">the page or link you are looking for is not avaible!</div>
      <div class="flex-mid">
        <el-button class="home-page" @click="openLink('ladingPage')">Our Website</el-button>
        <!-- <div class="mx-16"></div>
        <el-button class="home-page" @click="openLink">Happily for Admin</el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pageNotFound",
  mounted () {
    document.title = "My Happily - Page not found!";
  },
  methods: {
    openLink(value) {
      if (value === "ladingPage") {
        window.open("https://happily.ai/", "_self");
      } else {
        window.open("https://my.happily.ai/", "_self");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes lightenText {
  0% {color: #74747430;}
  29% {color: #74747430;}
  31% {color: #74747410;}
  32% {color: #74747403;}
  34% {color: #74747410;}
  36% {color: #74747400;}
  38% {color: #74747430;}
  100% {color: #74747430;}
}
.page-not-found {
  color: #74747430;
  height: 100vh;
}
.number {
  font-size: 200px;
  font-weight: 800;
  animation: lightenText;
  animation-duration: 8s;
  animation-iteration-count: infinite;
}
#pageNotFound .el-button.home-page {
  margin-left: 0;
  font-weight: 700;
  font-size: 18px;
  height: 52px;
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #fff;
}
</style>